import React from 'react';

import PrivateLayout from '../layouts/PrivateLayout';
import { useUser } from '../../contexts/UserContext';
import CadenceEditorOverlay from '../operations/onboardingSupport/CadenceEditorOverlay';

// Admin > Cadence Editor (Nic 2026-10-23): its own page, admins only
// (onboarding_cadence:edit / :approve, migration 218). It used to open over
// the Sales board from the Settings menu.
const CadenceEditorPage = () => {
  const { hasPermission } = useUser();
  return (
    <PrivateLayout hideFooter fluid>
      <div className="w-full pb-4">
        <CadenceEditorOverlay
          open
          asPage
          onClose={() => {}}
          canEdit={hasPermission('onboarding_cadence:edit')}
          canApprove={hasPermission('onboarding_cadence:approve')}
        />
      </div>
    </PrivateLayout>
  );
};

export default CadenceEditorPage;
